import { getJwt, setJwt } from './jwtLocalstorage'
import config from '../config'

const ERROR_TEXT = 'Error refreshing token'

const wasLoggedIn = () => {
  try {
    const token = getJwt()
    if (!token) {
      throw new Error('no token in local storage')
    }
    const [, jwtBody] = token.split('.')
    const { cheggTokens } = JSON.parse(atob(jwtBody))
    return !!(cheggTokens && cheggTokens.access_token)
  } catch (e) {
    return false
  }
}

const endpoint = () => {
  const path = wasLoggedIn() ? '/refresh' : '/token'
  return `${config.getAuthApiUrl()}${path}?client=wbe`
}

const refresh = async () => {
  try {
    const updateHostApp: (jwt: string) => void = config.getOnAuthUpdate()

    const authResponse = await fetch(endpoint(), {
      method: 'post',
      credentials: 'include',
    })

    const data = await authResponse.json()

    setJwt(data.jwt)

    // This is necessary to keep the redux store in sync in the host app with the widget.
    // To call set user incase anything has changed
    if (updateHostApp) {
      updateHostApp(data.jwt)
    }
    return Promise.resolve(data.jwt as string)
  } catch (error) {
    return Promise.reject(new Error(ERROR_TEXT))
  }
}

const wfeTokenRefresh = async (response?: Response) => {
  const status = response ? response.status : undefined

  if (!response || status === 401 || status === 403) {
    return await refresh()
  }
  return Promise.reject(new Error(response ? JSON.stringify({ status: response.status }) : ERROR_TEXT))
}

export default wfeTokenRefresh
